import { isMultilangPocEnabled } from '../../../constants/featureFlags'
import { useProjectId } from '../../../hooks/useProjectId'
import { ProjectBreadcrumb } from '../ProjectBreadcrumb'
import { useWaveId } from './useWaveId'

/** A wave's steps. Goes back to the tracker project, not the projects list. */
export const WAVE_FLOW_STEPS = [
  'Wave',
  'De-dup',
  'Audiences',
  'Survey',
  'Translations',
  'Tracking',
  'Confirm',
  'Results'
]

const PATH_BY_STEP: Record<string, string> = {
  Wave: '',
  'De-dup': 'dedup',
  Audiences: 'audiences',
  Survey: 'survey',
  Translations: 'translations',
  Tracking: 'tracking',
  Confirm: 'confirm',
  Results: 'results'
}

export const WaveFlowBreadcrumb = ({ activeStep }: { activeStep: string }) => {
  const projectId = useProjectId()
  const waveId = useWaveId()
  const waveRoot = `/project/${projectId}/wave/${waveId}`
  // Gated with its route in WaveRoutes, as in the multi-market flow.
  const steps = isMultilangPocEnabled()
    ? WAVE_FLOW_STEPS
    : WAVE_FLOW_STEPS.filter((step) => step !== 'Translations')

  return (
    <ProjectBreadcrumb
      activeStep={activeStep}
      backLabel="To Project"
      backTo={`/project/${projectId}`}
      steps={steps.map((label) => {
        const step = PATH_BY_STEP[label]
        return { label, path: step ? `${waveRoot}/${step}` : waveRoot }
      })}
    />
  )
}
